export default __webpack_public_path__ + "static/media/logo.29b81a69.png";